import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type { IAppDispatch, IAppState, IAppStore } from './interfaces';
import type { Dispatch } from 'redux';

/* State */
export const appInitialState: IAppState = {
    trigger: new Date(),
    error: undefined,
};

/* Selectors */
export const appSelectors = ({ app }: IAppStore): IAppState => app;

/* Dispatch */
export const appDispatch = (dispatch: Dispatch): IAppDispatch => ({
    dispatchTriggerChange: () => dispatch(triggerChange()),
    dispatchErrorOccured: (details) =>
        dispatch(
            errorOccured(
                typeof details === 'string' ? details : details?.message,
            ),
        ),
});

/* Slice */
const appSlice = createSlice({
    name: 'app',
    initialState: appInitialState,
    reducers: {
        triggerChange: (state) => {
            state.trigger = new Date();
        },
        errorOccured: (state, action: PayloadAction<string | undefined>) => {
            state.error = action.payload;
        },
    },
});

export const { triggerChange, errorOccured } = appSlice.actions;

export const appReducer = appSlice.reducer;
